import { ROUTES } from "@via/utils/constants.tsx";
import type { JSX } from "react";
import { Link } from "react-router-dom";

export const ChallengeGone = (): JSX.Element => (
  <div className="text-center">
    <h2 className="via-h2 text-2xl font-bold">This sign-in step expired</h2>
    <p className="mt-2 text-sm text-gray-600">
      It was already used, or more than five minutes passed. Please sign in
      again.
    </p>
    <Link
      to={ROUTES.LOGIN}
      className="mt-6 inline-block text-sm font-semibold text-indigo-600 hover:text-indigo-500">
      Sign in again
    </Link>
  </div>
);

export const LockedNotice = ({ until }: { until: string }): JSX.Element => (
  <div className="text-center">
    <h2 className="via-h2 text-2xl font-bold">Too many wrong codes</h2>
    <p className="mt-2 text-sm text-gray-600">
      Too many wrong codes were entered for this account. Try again after{" "}
      {new Date(until).toLocaleTimeString()}. If you lost your phone, use a
      recovery code then, or ask your administrator.
    </p>
  </div>
);

/** After a recovery code sign-in: how many codes are left, and where to replace the lost authenticator. */
export const RecoveryCodesRemaining = ({
  remaining,
  onContinue,
}: {
  remaining: number;
  onContinue: () => void;
}): JSX.Element => (
  <div className="space-y-4 text-center">
    <h2 className="via-h2 text-2xl font-bold">You are signed in</h2>
    <p data-testid="mfa-recovery-remaining" className="text-sm text-gray-600">
      You have {remaining} recovery {remaining === 1 ? "code" : "codes"} left.
      Each one works once. If you lost your phone, set up a new authenticator
      and create new recovery codes on your security page.
    </p>
    <Link
      to={ROUTES.PROFILE_SECURITY}
      className="inline-block text-sm font-semibold text-indigo-600 hover:text-indigo-500">
      Set up a new authenticator
    </Link>
    <button
      type="button"
      onClick={onContinue}
      className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500">
      Continue
    </button>
  </div>
);
